import { getSdk } from 'gql'
import { GraphQLClient } from 'graphql-request'

const endpoint =
  process.env.REACT_APP_GRAPHQL_PUBLIC_ENDPOINT ??
  'https://api-mainnet.defire.fi/query'
const client = new GraphQLClient(endpoint)
export const graphqlSdk = getSdk(client)
